import { render } from "./TabSetLayout.vue?vue&type=template&id=4573e705&scoped=true"
import script from "./TabSetLayout.vue?vue&type=script&lang=js"
export * from "./TabSetLayout.vue?vue&type=script&lang=js"

import "./TabSetLayout.vue?vue&type=style&index=0&id=4573e705&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4573e705"

export default script